<template>
  <v-container fluid>
    <v-row class="ma-3" wrap>
      <!-- Descrição -->
      <v-col cols="12">
        <v-text-field
          v-model="competencia.descricao"
          ref="descricao"
          label="Descrição"
          placeholder="Digite a descrição da área de atuação"
          dense
          outlined
          data-vv-as="descrição"
          persistent-hint
          :hint="errors.first('res_competencia.descricao')"
          :error="
            errors.collect('res_competencia.descricao').length ? true : false
          "
          v-validate="'required|min:3|max:150'"
          data-vv-scope="res_competencia"
          data-vv-validate-on="change"
          id="descricao"
          name="descricao"
        >
        </v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "CompetenciaForm",
  inject: ["$validator"],
  computed: {
    competencia: {
      get() {
        return this.$store.getters["resVagasCompetencias/getVagaCompetencia"];
      },
      set(value) {
        this.$store.dispatch("resVagasCompetencias/setVagaCompetencia", value);
      },
    },
  },
};
</script>

<style></style>
